import {
  GUIDED_HIGHLIGHTING_MAX_ATTEMPTS,
  GUIDED_HIGHLIGHTING_QUESTION_STATUSES,
  IGuidedHighlightingQuestion,
  IPreviousAnswer,
} from "./types";

const MAX_TOKENS_VALUE = 10;

export const snakeToCamel = (str: string) =>
  str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

export const convertResponse = (response: any) => {
  const parentKeys = Object.keys(response);
  for (const key of parentKeys) {
    const currentObj = response[key];
    delete response[key];
    const newKey = snakeToCamel(key);
    response[newKey] = currentObj;
    if (typeof response[newKey] === "object") {
      convertResponse(response[newKey]);
    }
  }
  return response;
};

export const updateQuestionData = (
  questions: IGuidedHighlightingQuestion[],
  reportedList: string[],
  previousAnswers: IPreviousAnswer[],
) => {
  for (const question of questions) {
    const answers = previousAnswers.filter(
      (answer) => answer.metadata.question_id === question.id,
    );
    const lastAnswer = answers.at(-1);
    const hasHitMaxAttempts =
      answers.length >= GUIDED_HIGHLIGHTING_MAX_ATTEMPTS;
    const isAnyResponseCorrect = answers.some(
      (answer) => answer.metadata.is_correct,
    );
    const tokensEarned = isAnyResponseCorrect
      ? MAX_TOKENS_VALUE / answers.length
      : 0;

    let status = GUIDED_HIGHLIGHTING_QUESTION_STATUSES.initial;
    if (isAnyResponseCorrect || hasHitMaxAttempts) {
      status = GUIDED_HIGHLIGHTING_QUESTION_STATUSES.completed;
    } else if (answers.length > 0) {
      status = GUIDED_HIGHLIGHTING_QUESTION_STATUSES.tryAgain;
    }
    question.isCorrect = isAnyResponseCorrect;
    question.attempt = answers.length;
    question.startIndex = Number(lastAnswer?.start_index) || 0;
    question.endIndex = Number(lastAnswer?.end_index) || 0;
    question.selectedText = lastAnswer?.metadata.text || "";
    question.tokensEarned = tokensEarned;
    question.status = status;
  }
  /* Excluding questions reported by the teacher as problematic */
  return questions.filter(({ id }) => !reportedList.includes(id));
};
